import { Drawer, message } from "antd";
import React, { useState } from "react";
import styles from "./TicketProcessingRulesForm.module.scss";
import {
  fieldConstants,
  formHeaderStyle,
  processingRuleFormConstants,
  ruleEngineMessages,
  ruleFormFields,
} from "./constants";
import {
  ButtonShape,
  ButtonSize,
} from "../../../../enums/ButtonAttributesEnums";
import InputField from "../../../../reusable-components/TNInputField";
import TNButton from "../../../../reusable-components/TNButton";
import { useFormContext } from "react-hook-form";
import RuleEngineServices from "../../../../services/ruleEngine.services";
import { UpdateRuleEngineContentType } from "../../../../Types/ruleEngineTypes";
import TNLoader from "../../../../reusable-components/TNLoader";

interface TicketProcessingRulesFormProps {
  id?: string;
  isOpen: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
}

const TicketProcessingRulesForm = (props: TicketProcessingRulesFormProps) => {
  const [formKey, setFormKey] = useState(0);
  const { isOpen, handleClose, handleSubmit, id } = props;
  const { getValues, reset } = useFormContext();
  const { UpdateRuleEngineContents } = RuleEngineServices();
  const { mutateAsync: updateRuleEngineContents, isPending } =
    UpdateRuleEngineContents();
  const handleCloseAction = () => {
    setFormKey((prev) => prev + 1);
    reset();
    handleClose();
  };

  const handleSaveAction = async () => {
    const payload: UpdateRuleEngineContentType = {
      id: id,
      uniqueSubmissions: getValues(fieldConstants.UNIQUE_SUBMISSIONS_NAME),
      notes: getValues(fieldConstants.NOTES_FIELD_NAME),
      failureLimit: getValues(fieldConstants.FAILURE_LIMIT_NAME),
      uniqueUsers: getValues(fieldConstants.UNIQUE_USERS_NAME),
      maxSubmissionsByUser: getValues(fieldConstants.MAX_SUBMISSIONS_NAME),
    };
    await updateRuleEngineContents(payload, {
      onSuccess: () => {
        message.success(ruleEngineMessages.success);
        handleCloseAction();
      },
      onError: () => {
        message.error(ruleEngineMessages.error);
      },
    });
  };
  const DrawerHeader = (
    <div className={styles.DrawerHeaderContainer}>
      <p>{processingRuleFormConstants.HEADER_TXT}</p>
    </div>
  );

  const DrawerFooter = (
    <div className={styles.DrawerFooterContainer}>
      <TNButton
        className={processingRuleFormConstants.CANCEL_BTN_CLASS}
        shape={ButtonShape.DEFAULT}
        size={ButtonSize.LARGE}
        text={processingRuleFormConstants.CANCEL_BTN_TXT}
        onClick={handleCloseAction}
      />
      <TNButton
        shape={ButtonShape.DEFAULT}
        size={ButtonSize.LARGE}
        text={processingRuleFormConstants.SAVE_BTN_TXT}
        onClick={handleSubmit(() => handleSaveAction())}
      />
    </div>
  );

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Drawer
        key={formKey}
        visible={isOpen}
        maskClosable={false}
        destroyOnClose
        mask={true}
        closable={true}
        getContainer={false}
        placement={processingRuleFormConstants.DRAWER_PLACEMENT}
        size={processingRuleFormConstants.DRAWER_SIZE}
        title={DrawerHeader}
        footer={DrawerFooter}
        headerStyle={formHeaderStyle}
        className={styles.processingRuleForm}
        height={processingRuleFormConstants.DRAWER_HEIGHT}
        width={processingRuleFormConstants.DRAWER_WIDTH}
        onClose={handleCloseAction}
      >
        <div className={styles.inputFieldsWrapper}>
          {ruleFormFields.map((field) => (
            <InputField
              type={field.type}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              maxLength={field.maxLength}
            />
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default TicketProcessingRulesForm;
